import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import SODAuthorizedFilers from '../../container/modules/companyMngmt/authorizedFilers';

const NotFound = lazy(() => import('../../container/pages/404'));
const SubmissionsList = lazy(() => import('../../container/modules/submissions/list'));
const SubmissionsView = lazy(() => import('../../container/modules/submissions/view'));
const ReclassifyForm = lazy(() => import('../../container/modules/submissions/reclassify'));
const ReclassifyView = lazy(() => import('../../container/modules/submissions/reclassifyView'));
const CompanyList = lazy(() => import('../../container/modules/companyMngmt/list'));
const CompanyView = lazy(() => import('../../container/modules/companyMngmt/view'));

function PagesRoute() {
  return (
    <Routes>
      {/* <Route path="profile" element={<Profile />} /> */}
      <Route path="*" element={<NotFound />} />
      <Route path="authorized-filers/*" element={<SODAuthorizedFilers />} />
      <Route path="submissions-list" element={<SubmissionsList />} />
      <Route path="submissions-view" element={<SubmissionsView />} />
      <Route path="submissions-reclassify" element={<ReclassifyForm />} />
      <Route path="submissions-reclassify-view" element={<ReclassifyView />} />
      <Route path="companies-list" element={<CompanyList />} />
      <Route path="companies-view" element={<CompanyView />} />
      {/* <Route path="forms" element={<FormsPage />} /> */}
    </Routes>
  );
}

export default PagesRoute;
